import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { PermissionUrlService } from "./../../../shared/services/permissions.service";

@Component({
  selector: 'widget-wrapper',
  templateUrl: './widget-wrapper.component.html',
  styleUrls: ['./widget-wrapper.component.scss']
})
export class WidgetWrapperComponent implements OnInit, OnChanges {
  @Input() WIDGETCONFIGS; 
  @Input() CHARTCONFIGS; 
  @Input() FILTERS;

  constructor(private WIDGET_PERMISSIONS: PermissionUrlService) { }

  ngOnInit() {
  }

  ngOnChanges(changes){
  }

}
